import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY, ObservableInput }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
import { DataService } from 'app/data.service';

@Injectable({
  providedIn: 'root'
})
export class AdPlanResolverService implements Resolve<any>{

  constructor( private neproseService: DataService, private router: Router) { }

  resolve(): Observable<any> | Observable<never>{
    return this.neproseService.adPlans().pipe(
      take(1),
      mergeMap<any, ObservableInput<any>>(adPlans=> {
        if (adPlans) {
          if(adPlans.adPlans){
            return of(adPlans.adPlans);
          }else{
            this.router.navigate(['']);
          }
        } else {
          this.router.navigate(['']);
        }
      })
    )
  }
}
